import { createContext, useEffect, useState } from "react";

export const NssReportContentContext = createContext();

const initialReportContentState = {
  nssActivities: "",
};

export const NSS_ACTIVITIES = "nssActivities";

export const NssReportContentContextProvider = ({ children }) => {
  const [content, setContent] = useState(initialReportContentState);

  const setSubTitle = (subTitle, subTitleContent) => {
    setContent((content) => {
      const newContent = {
        ...content,
      };
      newContent[subTitle] = subTitleContent;
      return newContent;
    });
  };

  const getSubTitle = (subTitle) => {
    return content[subTitle];
  };

  useEffect(() => {
    // Get the content from the backend and use setContent to set the same
    console.log(content);
  }, [content]);

  return (
    <NssReportContentContext.Provider
      value={{ content, setContent, setSubTitle, getSubTitle }}
    >
      {children}
    </NssReportContentContext.Provider>
  );
};
